import React from 'react';
import complementosList from './ComplementosList';

const Complementos = (props) => {
  const { data, complemento, complementos = {}, onChange } = props;

  let Complemento = null;

  if (complemento) {
    Complemento = complementosList[complemento];
  }

  const handleOnChange = (data) => {
    onChange({
      ...complementos,
      ...data
    });
  }

  const handleOnCancel = (complemento) => {
    onChange({
      ...complementos,
      [complemento]: undefined,
    });
  }

  return (
    <div className="py-3">
      { !!Complemento && (
        <Complemento data={ data }
          onChange={ handleOnChange }
          onCancel={ handleOnCancel }
        />
      )}
    </div>
  )
}

export default Complementos;
